import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IApps {
  id: string;
  isApproved: boolean;
  userId: number;
  companyId: number;
  clientIp: string | null;
  /** Workload identity uygulamalarında null — anahtar çifti üretilmez. */
  keyId: string | null;
  /** Doluysa uygulama kendi anahtarı yerine bu issuer'ın JWKS'i ile doğrulanır. */
  issuer: string | null;
  /** Beklenen `sub` claim'i; boşsa issuer'ın TÜM token'ları geçerli olur. */
  subject: string | null;
}

export class IAppsResponse {
  @Type(() => IApps)
  result: IApps;
}

export class IAppsListResponse extends IPagination {
  @Type(() => IApps)
  results: IApps[];
}

export class IAppsQueryDto extends IQueryPaginationDto {
  id?: string;
}

export class IAppsPostDto {
  userId: number;
  companyId: number;
  isApproved: boolean;
  clientIp: string | null;
  issuer?: string | null;
  subject?: string | null;
}

export class IAppsPatchDto {
  userId?: number;
  isApproved?: boolean;
  clientIp?: string | null;
  issuer?: string | null;
  subject?: string | null;
}
